import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/slack-hash': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M446.2 270.4c6.2 19-3.9 39.7-22.9 45.7l-45.4 15.1 15.7 47c6.1 19.1-3.9 39.7-23 45.9-21.3 6.1-40.1-6-46-22.9l-15.7-47-93.6 31.3 15.7 47c6.1 19.1-3.9 39.7-23 45.9-21.3 6.1-40.1-6-46-22.9l-15.7-47c-45.7 15.2-50.9 17.8-57.7 16.8-14.5-0.6-28.6-10.1-33.6-24.6-6.1-19 4-39.7 23-45.9l45.4-15.1-30.3-90c-45.7 15.2-50.9 17.8-57.7 16.8-14.5-0.6-28.6-10.1-33.6-24.6-6.1-19.1 3.9-39.7 23-45.9l45.3-15-15.7-47c-6.1-19.1 3.9-39.7 23-45.9 19.1-6.2 39.8 3.9 46 22.9l15.7 47 93.4-31.2-15.7-47c-6.1-19.1 3.9-39.7 23-45.9 19.1-6.2 39.8 3.9 46 22.9l15.7 47 45.4-15.1c19.1-6.2 39.8 3.9 46 22.9 6.1 19.1-3.9 39.7-23 45.9l-45.4 15.1 30.3 90 45.4-15.1c19.1-6.2 39.8 3.9 46 22.9zM192.1 317.6l93.5-31.3-30.3-90.2-93.5 31.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/slack-hash.js
// module id = 1019
// module chunks = 0